import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
/**
 * @param {?} minLineCount
 * @return {?}
 */
export function minLines(minLineCount: number): ValidatorFn {

  return (c: AbstractControl): null | ValidationErrors => {

    if (c.value) {
      const /** @type {?} */ lineCount = c.value.length;

      if (lineCount < minLineCount) {
        return {
          minLines: {
            lineCount: lineCount,
            minLineCount: minLineCount,
            message: `Signature must have a minimum line count of ${minLineCount}.`
          }
        };
      }
      return null;
    }
    return null;
  }
}
